import httpService from "./httpService";

export default {
  getHcFlowAlternativeForHcCaseCalendar() {
    return httpService.get("/hcFlow/getHcFlowAlternativeForHcCaseCalendar");
  },

  getHcFlowAlternativeForHcCommands() {
    return httpService.get("/hcFlow/getHcFlowAlternativeForHcCommands");
  },

  getHcFlowAlternativeForHcDieuXe() {
    return httpService.get("/hcFlow/getHcFlowAlternativeForHcDieuXe");
  },

  findAllDieuXeHcFlowWhichUserCanStart() {
    return httpService.get("/hcFlow/findAllDieuXeHcFlowWhichUserCanStart");
  },

  findAllDieuXeHcFlowWhichUserCanApprove() {
    return httpService.get("/hcFlow/findAllDieuXeHcFlowWhichUserCanApprove");
  },

  getHcFlowAlternativeForHcFlight() {
    return httpService.get("/hcFlow/getHcFlowAlternativeForHcFlight");
  },

  getHcFlowAlternative(flowCode) {
    let params = { flowCode: flowCode };
    return httpService.get("/hcFlow/getHcFlowAlternative", { params: params });
  },

  findAllHcCaseFlightFlowWhichUserCanApprove() {
    return httpService.get(
      "/hcFlow/findAllHcCaseFlightFlowWhichUserCanApprove"
    );
  },

  findAllHcCaseCommonFlowWhichUserCanApprove(flowCode) {
    let params = { flowCode: flowCode };
    return httpService.get(
      "/hcFlow/findAllHcCaseCommonFlowWhichUserCanApprove",
      { params: params }
    );
  },

  findById(id) {
    return httpService.get(`/hcFlow/${id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/hcFlowService.js